export default {
  googleMapsAPIKey: 'AIzaSyADpMNzeHJB_5VBmkyxEA25i8GJSRrFFlE',
  zoom: 16,
}
